import React, { useState, useEffect } from "react";
import { BsGlobe } from "react-icons/bs";
import TableData from "./Table/TableData";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getAuthorization } from "../../../axios/AxiosAut";
import Swal from "sweetalert2";
import "animate.css";
import { RiDeleteBinLine } from "react-icons/ri";
export default function General() {
  const Navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const ID = state;
  const DeleteHandler = () => {
    getAuthorization()
      .delete(`warehouse/delete_warehouse/?id=${ID}`)
      .then((res) => {
        console.log("Warehouse successfully deleted");
        Swal.fire({
          position: "top-end",
          title: "Warehouse Deleted!",
          showConfirmButton: false,
          timer: 3500,
          showClass: {
            popup: "animate__animated animate__fadeInRight",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutRight",
          },
          width: 300,
          color: "#FFFFFF",
          background: "#2A91D7",
          backdrop: `rgba(0,0,0,0)`,
        });
        Navigate("/dashboard/warehouse/warehouse-list");
      })
      .catch((err) => {
        console.log("error in deleting the supplier");
      });
  };
  const [WarehouseDetails, setWarehouseDetails] = useState({});
  // useEffect(() => {
  //   //Get details of a warehouse
  //   getAuthorization()
  //     .get(`warehouse/get_warehouse_scene/?id=${ID}`)
  //     .then((res) => {
  //       setWarehouseDetails(res.data);
  //     })
  //     .catch((err) => {
  //       console.log("Error in getting customer details", err);
  //     });
  // }, []);
  // console.log("WarehouseDetails",WarehouseDetails)
  return (
    <div>
      <h2 className="font-Montserrat text-xl font-medium text-black">
        The Warehouse Name
      </h2>
      <div class="flex flex-wrap justify-center mt-2">
        <div className="w-full font-Montserrat flex-2 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6">
          <div className="flex flex-row pl-3 space-x-3 mt-4">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="10.0046"
                cy="10.0026"
                r="5.00067"
                stroke="#1F78B4"
                stroke-width="2"
              />
              <path d="M10 4.00044V0" stroke="#1F78B4" stroke-width="2" />
              <path d="M10 20.0007V16.0002" stroke="#1F78B4" stroke-width="2" />
              <path
                d="M19.9998 10L15.1992 10"
                stroke="#1F78B4"
                stroke-width="2"
              />
              <path
                d="M4.80053 9.99951L0 9.99951"
                stroke="#1F78B4"
                stroke-width="2"
              />
              <circle
                cx="10.0034"
                cy="10.0015"
                r="2.30031"
                fill="#1F78B4"
                stroke="#1F78B4"
              />
            </svg>
            <p className="font-Roboto text-base text-gray-600">
              Door number, Street name, Postcode, City, Country
            </p>
          </div>
          
          <div className="flex flex-row pl-3 space-x-3 mt-4">
            <BsGlobe size={24} color="#1F78B4" />
            <p className="font-Roboto text-base text-gray-600">
              www.website.com
            </p>
          </div>

          <div className="flex flex-row pl-3 space-x-3 mt-4">
            <svg
            className="ml-1"
              width="16"
              height="24"
              viewBox="0 0 16 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.9995 22.621L12.4785 15.826C12.4705 15.83 10.5045 16.796 10.4145 16.837C8.17455 17.923 3.61555 9.017 5.80555 7.843L7.88855 6.817L4.39555 0L2.28955 1.039C-4.91245 4.794 6.52255 27.021 13.8895 23.654C14.0105 23.599 15.9915 22.625 15.9995 22.621Z"
                fill="#1F78B4"
              />
            </svg>

            <p className="font-Roboto text-base text-gray-600">077448093</p>
          </div>
        </div>
      </div>
      
      <div className="flex mt-8 flex-wrap justify-center">
      <div
        className="tabelcontainer flex-auto  overflow-auto mx-4"
        // "w-[calc(100vw_-_12rem)]"
      >

      <TableData/>
      </div>
    </div>

      <div className="flex flex-row justify-center space-x-128 mt-12 mb-0 my-10">
        <button
          type="button"
          className="text-red-600 font-Montserrat font-medium text-lg"
          onClick={() => Navigate("/dashboard/warehouse/warehouse-list")}
        >
          Go Back
        </button>
        <div className="flex flex-row space-x-3">
          <div className="pt-1.5">
            <RiDeleteBinLine height={16} width={16} fill="#b91c1c" />
          </div>

          <button
            className="text-red-700 font-Montserrat font-medium text-lg"
            onClick={() => DeleteHandler()}
          >
            Delete Warehouse
          </button>
        </div>
      </div>
    </div>
  );
}
